import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { courseLessonStep, finishCourse } from '../../../../../redux/actions/courses'
import { deleteLessonMultimedia, setViewLesson, storeLessonMultimedia } from '../../../../../redux/actions/lessons'
import { IRootState } from '../../../../../redux/types'
import { UseLessonsDetailProps } from '../../models/lessons'

export const useLessonsDetail = ({ lesson, course }: UseLessonsDetailProps) => {
  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { error, msg } = useSelector((state: IRootState) => state.lesson)
  const [lessonMultimediaSelected, setLessonMultimediaSelected] = useState<any>(null)
  const [showEditLessonMultimedia, setShowEditLessonMultimedia] = useState(false)
  const [currentTab, setCurrentTab] = useState(0)

  useEffect(() => {
    window.scrollTo(0, 0)
    if (authUser !== null) {
      dispatch(
        courseLessonStep({
          course_id: course.id,
          lesson_order: lesson.order
        })
      )
    }
  }, [authUser, course.id, lesson.order, dispatch])

  const handleChangeLesson = (order: number) => {
    const targetLesson = course.lessons.find((lessonValue: any) => lessonValue.order === order)

    if (targetLesson) {
      dispatch(setViewLesson(targetLesson))
    }

    if (authUser !== null) {
      dispatch(
        courseLessonStep({
          course_id: course.id,
          lesson_order: order
        })
      )
    }
  }

  const handleFinishLesson = () => {
    dispatch(finishCourse(course.id))
  }

  const handleEditMediaFileBlock = (lessonMultimedia: any) => {
    setLessonMultimediaSelected(lessonMultimedia)
    setShowEditLessonMultimedia(true)
  }

  const handleCloseEditLessonMultimedia = () => {
    setLessonMultimediaSelected(null)
    setShowEditLessonMultimedia(false)
  }

  const handleDownloadMediaFileBlock = (fileName: string) => {
    window.open(`${import.meta.env.VITE_API_URL}/lessons/download/${fileName}`)
  }

  const handleDeleteMediaFileBlock = (id_lessonmultimedia: number) => {
    const index = lesson.multimedia.findIndex((multimedia: any) => multimedia.id === id_lessonmultimedia)

    if (index !== -1) {
      lesson.multimedia.splice(index, 1)
      dispatch(setViewLesson(lesson))
      dispatch(deleteLessonMultimedia(id_lessonmultimedia))
    }
  }

  const handleSubmit = () => {
    if (lessonMultimediaSelected) {
      dispatch(storeLessonMultimedia(lessonMultimediaSelected))
      setLessonMultimediaSelected(null)
      setShowEditLessonMultimedia(false)
    }
  }

  const getUploadParams =
    (prop: string) =>
    ({ meta }: any) => {
      setLessonMultimediaSelected({
        ...lessonMultimediaSelected,
        [prop]: meta.name
      })
      return {
        url: `${import.meta.env.VITE_API_URL}/lessons/uploaddropzone/${meta.name}`
      }
    }

  const handleTabChange = (_event: any, newValue: number) => {
    setCurrentTab(newValue)
  }

  const hasMultimedia = lesson.multimedia.length > 0
  const isLastLesson = course.lastOrder === lesson.order
  const isFirstLesson = lesson.order === 1
  const showFinishButton = authUser !== null

  const hasVipAccess =
    course.visibility === 1 &&
    (authUser?.vip_lines.includes(course.line_id) ||
      (course.line_id === null && authUser?.vip_brands.includes(course.brand_id)) ||
      [1, 2, 3, 5].includes(authUser?.role_id))

  return {
    lessonMultimediaSelected,
    showEditLessonMultimedia,
    currentTab,
    error,
    msg,
    authUser,
    handleChangeLesson,
    handleFinishLesson,
    handleEditMediaFileBlock,
    handleCloseEditLessonMultimedia,
    handleDownloadMediaFileBlock,
    handleDeleteMediaFileBlock,
    handleSubmit,
    handleTabChange,
    getUploadParams,
    hasMultimedia,
    isLastLesson,
    isFirstLesson,
    showFinishButton,
    hasVipAccess
  }
}
